var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadgeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55.8 66.1",
    style: {
      enableBackground: "new 0 0 55.8 66.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st1{fill:#14A800;stroke:#000000;stroke-width:1.5;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible",
      enableBackground: "new"
    },
    width: 64,
    height: 72,
    xlinkHref: "images/badge-icon.png",
    transform: "matrix(1 0 0 1 -6.7384 -4.7095)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.6,
    cy: 23.7,
    r: 17.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.6,23.7c0,12.7-10.3,22.9-22.9,22.9c-6.1,0-11.6-2.4-15.7-6.2c-4.4-4.2-7.2-10.1-7.2-16.7 C4.7,11,15,0.8,27.6,0.8S50.6,11,50.6,23.7z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "11.7,40.8 1.6,57.3 11.7,54.7 13.8,63.9 23.2,46.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "43.1,39.8 54.2,57.3 44.1,54.7 42,63.9 32.6,46.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "27.6,14.1 29.8,20.7 36.7,20.7 31.1,24.7 33.2,31.3 27.6,27.2 22.1,31.3 24.2,24.7 18.6,20.7  25.5,20.7  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIcon);
export default __webpack_public_path__ + "static/media/badge-icon.e62fb88d7b08d5cfd4538a82daf60064.svg";
export { ForwardRef as ReactComponent };